export class WebinarSearch {
	init() {
		const webinarFilter = document.querySelectorAll('.webinar-category-filter');
		webinarFilter.forEach(filter => {
			filter.addEventListener('change', (e) => {
				this.pastWebinarFilter(e.target.value);
			});
		});
		if(webinarFilter.length > 0){
			// Check for filter parameter in URL
			const urlParams = new URLSearchParams(window.location.search);
			const filterParam = urlParams.get('filter');

			// Set the filter value if it exists in URL
			if (filterParam) {
				webinarFilter.forEach(filter => {
					filter.value = filterParam;
				});
			}

			this.pastWebinarFilter(filterParam || '');
			this.initMobileInterface();
		}
	}

	pastWebinarFilter = (category) => {
		const cards = document.querySelectorAll('.related-resources .card');
		let count = 0;
		cards.forEach(card => {
			const categories = card.dataset.categories ? card.dataset.categories.split(',').map(c => c.trim()) : [];
			const visible = category.length === 0 || categories.some(c => category.includes(c));
			card.style.display = visible ? '' : 'none';
			if(!visible){
				count++;
			}
		});

		// Update URL parameter
		const url = new URL(window.location);
		if (category) {
			url.searchParams.set('filter', category);
		} else {
			url.searchParams.delete('filter');
		}
		window.history.pushState({}, '', url);

		// Handle .page-webinar sections
		if (document.querySelector('.page-webinars')) {
			document.querySelectorAll('.related-resources').forEach(section => {
				const visibleCards = section.querySelectorAll('.card:not([style*="display: none"])').length;
				section.style.display = visibleCards > 0 ? '' : 'none';
			});
		}

		if(count === cards.length){
			document.querySelector('.related-resources').classList?.add('no-webinar-results');
		}else{
			document.querySelector('.related-resources').classList?.remove('no-webinar-results');
		}

		const noResultsElements = document.querySelectorAll('.resource-filter-section .no-results-found');
		if(cards.length - count === 0){
			noResultsElements.forEach(el => el.style.display = 'block');
		}else{
			noResultsElements.forEach(el => el.style.display = 'none');
		}

		const mobileResultsCount = document.querySelector('#mobile-resources-search-stats');
		if(mobileResultsCount){
			mobileResultsCount.innerHTML = `Results (${cards.length - count})`;
			if(cards.length - count === 0){
				console.log("!!");
				mobileResultsCount.style.display = 'none';
			}else{
				mobileResultsCount.style.display = 'block';
			}
		}
		const resultsCount = document.querySelector('#resources-search-stats');
		if(resultsCount){
			resultsCount.innerHTML = `Results (${cards.length - count})`;
			if(cards.length - count === 0){
				resultsCount.style.display = 'none';
			}else{
				resultsCount.style.display = 'block';
			}
		}
	}

	initMobileInterface() {
		const mobileModal = document.querySelector('.mobile-filter-modal-container');
		const mobileModalTrigger = document.querySelector('#mobile-filter-trigger');
		const mobileModalCloseBtn =  mobileModal.querySelector('button.close');
		const docHeader = document.querySelector('header.header');
		const applyFiltersBtn = document.querySelector('#mobile-apply-filters');
		let headerZ = 0;

		mobileModalTrigger.addEventListener('click', () => {
			mobileModal.classList.toggle('active');
			if (headerZ < 100) headerZ = docHeader.style.zIndex;
			docHeader.style.zIndex = 0;
		});
		mobileModalCloseBtn.addEventListener('click' , () => {
			mobileModal.classList.toggle('active');
			document.querySelector('header.header').style.zIndex = headerZ;
		});
		window.addEventListener('resize' , ()=>{
			if (mobileModal.classList.contains('active')) {
				mobileModal.classList.toggle('active');
				document.querySelector('header.header').style.zIndex = headerZ;
			}
		});

		applyFiltersBtn.addEventListener('click', () => {
			mobileModal.classList.toggle('active');
			document.querySelector('header.header').style.zIndex = headerZ;
		});
	}
}
